export default __webpack_public_path__ + "static/media/script-full-linux.64a8714a.avif";